import {BatchSchema} from 'constants/SampleConstants';
import {Schema} from 'schemas/SchemaConstants';
import {Filter, FilterErrors, isFieldFilter} from 'search/SearchConstants';

/**
 * @returns Array where the ith element is an error message for the ith filter, if invalid, else null
 */
export default function validateFieldFilters(
  filters: Array<Filter>,
  selectedSchema: Schema | BatchSchema | null
): FilterErrors {
  return filters.map((filter) => {
    if (isFieldFilter(filter)) {
      if (!selectedSchema) {
        return 'Please select a schema from the Type filter.';
      }
      if (filter.fieldId && !selectedSchema.allFields.map(({apiId}) => apiId).includes(filter.fieldId)) {
        return 'Please select a field present on the currently-selected schema.';
      }
    }
    return null;
  });
}
